import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MembershipPanelWrapper from "../../components/MembershipPanelWrapper";
import MembershipPolicyDocuments from "../../components/MembershipPolicyDocuments";
import { useEffect } from "react";
import { trackPageViewV2 } from "../../../../services/analytics-adapter";

export default function MembershipPolicyDocumentsPage() {
  const { t } = useTranslation();
  const { membershipIdentifier } = useParams();

  useEffect(() => {
    trackPageViewV2({
      pageName: "Membership:Membership policy documents",
      pageSubSection1: "Membership",
      pageSubSection2: "Membership:Membership policy documents",
      pageCategory: "Membership",
    });
  }, [membershipIdentifier]);

  return (
    <MembershipPanelWrapper
      goBackButtonText={t("common.backButton")}
      goBackButtonVisibleText={t("common.backButton")}
      title={t("MembershipPolicyDocumentsPage.title")}
    >
      <MembershipPolicyDocuments membershipIdentifier={membershipIdentifier} />
    </MembershipPanelWrapper>
  );
}
